<div class="container-fluid topnav  d-none d-lg-block">
    <div class="container">
        <div class="row ml-5">
            <div class="col-lg-6 col-7 fs-12  d-flex align-items-center  justify-content-start  ">
                <nav>
                    <!--<ul class="nav-inline">
        <li class="nav-item" *ngIf="!LoginDetails"><span class="nav-link nav-link1" routerLink="/job">Jobs</span></li>
        <li class="nav-item" *ngIf="!LoginDetails"><span class="nav-link nav-link1" routerLink="/CompanyProfile">Companies</span></li>
        <li class="nav-item" *ngIf="!LoginDetails"><span class="nav-link nav-link1">
           <a href="https://justlivetutors.com/home/courses" target="_blank">Just Live Tutors</a></span>
        </li>
        <li class="nav-item" *ngIf="LoginDetails || !LoginDetails && !userDetails1"><span class="nav-link nav-link1" routerLink="/postjobs">Post a Job </span></li>
        <li class="nav-item" *ngIf="LoginDetails || !LoginDetails && !userDetails1"><span class="nav-link nav-link1" routerLink="/Subscription">Subscription Details </span></li>
        <li class="nav-item" *ngIf="!LoginDetails"><span class="nav-link nav-link1" routerLink="/Freelancer">Freelancer </span></li>
    </ul>-->
                    <ul class="nav-inline" *ngIf="!LoginDetails && !userDetails1">
                        <li class="nav-item">
                            <span class="nav-link nav-link1" routerLink="/job">Jobs</span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link nav-link1" routerLink="/CompanyProfile">Companies</span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link nav-link1">
                                <a href="https://justlivetutors.com/home/courses" target="_blank">Just Live Tutors</a>
                            </span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link nav-link1" routerLink="/Freelancer">Freelancer</span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link nav-link1" routerLink="/postjobs">Post a Job</span>
                        </li>
                    </ul>

                </nav>
            </div>
            <div class="col-lg-2 d-none d-lg-block">
            </div>
            <!--<div class="col-lg-2 d-none d-lg-block" >
            </div>-->
            <div class="col-lg-2 d-none d-lg-block text-end border-end">
                <!-- Always show the number -->
                <a *ngIf="!(userDetails1 || LoginDetails)" href="tel:9000123456" target="_blank" class="fs-14">
                    <i class="fa fa-phone"></i> +91 9000123456
                </a>
            </div>

            <div class="col-lg-2 col-5 fs-12 d-flex align-items-center justify-content-end">
                <div class="top d-flex align-items-center ms-2">
                    <!-- Show "Recruiter's Login" button only if not logged in -->
                    <button *ngIf="!userDetails1 && !LoginDetails"
                            class="btn btn-primary text-white custom-btn text-nowrap"
                            (click)="Recuterlogin()">
                        <i class="bi bi-box-arrow-in-right me-2"></i> Recruiter's Login
                    </button>
                    <!-- Show the phone number if logged in -->
                    <a *ngIf="userDetails1 || LoginDetails"
                       href="tel:9000123456"
                       target="_blank"
                       class="fs-14 text-decoration-none">
                        <i class="fa fa-phone"></i> +91 9000123456
                    </a>
                </div>
            </div>


        </div>
    </div>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light"
     [class.active]="classApplied"
     [ngClass]="{ 'active': isMenuOpen, 'sticky': isSticky }">
    <div class="container">
        <a class="navbar-brand" (click)="home()">
            <img src="assets/img/images/logoo.png" class="logo_width_nav" alt="NJobs" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu" [ngClass]="{'class-name': classApplied}">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <!-- Show login/registration if neither recruiter nor jobseeker logged in -->
                <li class="nav-item" *ngIf="!userDetails1 && (!LoginDetails || LoginDetails.length === 0)">
                    <span class="nav-link" (click)="login()"><i class="bi bi-box-arrow-in-right me-2"></i>Login</span>
                </li>
                <li class="nav-item" *ngIf="!userDetails1 && (!LoginDetails || LoginDetails.length === 0)">
                    <span class="nav-link" (click)="Registration()"><i class="bi bi-card-text me-2"></i>Registration</span>
                </li>
            </ul>

            <!-- Username + Dropdown -->
            <div class="nav-link username-container" *ngIf="userDetails1 || (LoginDetails && LoginDetails.length > 0)">
                <span style="color:black" class="nav-link username">
                    <span class="hello"></span>{{ userDetails1?.FirstName || LoginDetails[0]?.RecruiterName }}
                </span>
                <ul class="dropdown-menu">
                    <!-- Job seeker menu -->
                    <ng-container *ngIf="userDetails1">
                        <li><span class="nav-link" (click)="manageaccount()">Manage Account</span></li>
                        <li><span class="nav-link" (click)="AppliedJobs()">Applied Jobs</span></li>
                        <li><span class="nav-link" (click)="ChangePassword()">Change Password</span></li>
                        <li><span class="nav-link" (click)="Logout()">Logout</span></li>
                    </ng-container>

                    <!-- Recruiter menu -->
                    <ng-container *ngIf="!userDetails1 && LoginDetails && LoginDetails.length > 0">
                        <li><span class="nav-link" (click)="ChangePassword()">Change Password</span></li>
                        <li><span class="nav-link" (click)="Logout()">Logout</span></li>
                    </ng-container>
                </ul>
            </div>

            <!-- Responsive menu (for mobile) -->
            <ul class="navbar-nav ml-auto for-responsive" [ngClass]="{'show': isMenuOpen}">
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/job">Jobs</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/CompanyProfile">Companies</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Career-insights">Post a Job</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Career-insights">Subscription Details</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Freelancer">Freelancer</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" (click)="Recuterlogin()">Recruiter's Login</span></li>
            </ul>
        </div>
    </div>
</nav>


<!--<nav class="navbar navbar-expand-lg navbar-light bg-light"
     [class.active]="classApplied"
     [ngClass]="{ 'active': isMenuOpen, 'sticky': isSticky }">
    <div class="container ">
        <a class="navbar-brand" (click)="home()">
            <img src="assets/img/images/logoo.png" class="logo_width_nav" alt="NJobs" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu" [ngClass]="{'class-name': classApplied}">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <ul class="navbar-nav ml-auto">
                <li class="nav-item" *ngIf="!userDetails1 && (!LoginDetails || LoginDetails.length === 0)">
                    <span class="nav-link" (click)="login()"><i class="bi bi-box-arrow-in-right me-2"></i>Login</span>
                </li>
                <li class="nav-item" *ngIf="!userDetails1 && (!LoginDetails || LoginDetails.length === 0)">
                    <span class="nav-link" (click)="Registration()"><i class="bi bi-card-text me-2"></i>Registration</span>
                </li>

                <li class="nav-item" *ngIf="LoginDetails && LoginDetails.length > 0 && !userDetails1">
                    <span class="nav-link" (click)="Logout()"><i class="bi bi-box-arrow-left me-2"></i>Logout</span>
                </li>
            </ul>

            <div class="nav-link username-container" *ngIf="userDetails1 || (LoginDetails && LoginDetails.length > 0)">
                <span style="color:black" class="nav-link username">
                    <span class="hello"></span>{{ userDetails1?.FirstName || LoginDetails[0]?.RecruiterName }}
                </span>
                <ul class="dropdown-menu">
                    <li *ngIf="!rgid"><span class="nav-link" (click)="manageaccount()">Manage Account</span></li>
                    <li *ngIf="!LoginDetails"><span class="nav-link" (click)="AppliedJobs()">Applied Jobs</span></li>
                    <li *ngIf="!rgid"><span class="nav-link" (click)="ChangePassword()">Change Password</span></li>
                    <li><span class="nav-link" (click)="Logout()">Logout</span></li>
                </ul>
            </div>

            <ul class="navbar-nav ml-auto for-responsive" [ngClass]="{'show': isMenuOpen}">
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/job">Jobs</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/CompanyProfile">Companies</span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Career-insights">Post a Job </span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Career-insights">Subscription Details </span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" routerLink="/Freelancer">Freelancer </span></li>
                <li class="nav-item" (click)="closeMenu()"><span class="nav-link" (click)="Recuterlogin()">Recruiter's Login </span></li>
                <li class="nav-item" (click)="closeMenu()" *ngIf="!userDetails1 && !LoginDetails"><span class="nav-link" (click)="login()">login</span></li>
                <li class="nav-item" (click)="closeMenu()" *ngIf="!userDetails1 && !LoginDetails"><span class="nav-link" (click)="Registration()">Registration</span></li>
                <li class="nav-item" (click)="closeMenu()">
                    <div class="nav-link username-container">
                        <span style="color:black" class="nav-link username"><span class="hello"></span>{{ userDetails1?.FirstName || (LoginDetails[0]?.RecruiterName || '') }}</span>
                        <ul class="dropdown-menu">
                            <li *ngIf="!rgid"><span class="nav-link" (click)="manageaccount()">Manage Account</span></li>
                            <li *ngIf="!rgid"><span class="nav-link" (click)="ChangePassword()">Change Password</span></li>
                            <li><span class="nav-link" (click)="Logout()">Logout</span></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>-->
<!-- Change Password Modal -->
<div class="modal fade" [ngClass]="{'show': showChangePasswordModal}" [ngStyle]="{'display': showChangePasswordModal ? 'block' : 'none'}" tabindex="-1" role="dialog" *ngIf="showChangePasswordModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Change Password</h5>
                <button type="button" class="btn-close" (click)="closePasswordModal()">&times;</button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-3">
                    <label for="currentPassword">Current Password</label>
                    <input type="password" class="form-control" id="currentPassword"
                           [(ngModel)]="currentPassword" placeholder="Enter current password">
                </div>
                <div class="form-group mb-3">
                    <label for="newPassword">New Password</label>
                    <div class="position-relative">
                        <input [type]="showNewPassword ? 'text' : 'password'" class="form-control" id="newPassword"
                               [(ngModel)]="newPassword" placeholder="Enter new password">
                        <button type="button" class="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
                                (click)="toggleNewPasswordVisibility()" style="z-index: 5; margin-right: 10px;">
                            <i [class]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </button>
                    </div>
                </div>
                <div class="alert alert-danger" *ngIf="passwordError">
                    {{ passwordError }}
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closePasswordModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="validateAndUpdatePassword()">Update Password</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showChangePasswordModal" (click)="closePasswordModal()"></div>
